import LicencasColaboradores from "../Modulos/InventarioTI/LicencasColaboradores";

export default function InventarioTILicencasColaboradoresRoute() {
  return <LicencasColaboradores />;
}
